import React from 'react';
import cls from './EstimateMeasurementsModalImages.module.css';
import { ImageList } from '../../UI/ImageList/ImageList';
import { useTranslation } from 'react-i18next';

export const EstimateMeasurementsModalImages = () => {
    const { t } = useTranslation();

    return (
        <div className={cls.container}>
            <span className={cls.ImageListTitle}>
                {t('EstimateMeasurementsModalImages.return.ImageListTitle')}
            </span>
            <ImageList />
        </div>
    );
};
